<template>
  <div class="v2-blog-list">
    <span class="bg-sticker rainbow">
      <img v-lazy="rainbowSticker" :alt="`sticker rainbow`" />
    </span>

    <div v-masonry class="masonry" transition-duration="0.3s" item-selector=".item">
      <div v-for="post in posts" :key="post.id" v-masonry-tile class="item">
        <blog-list-item-v2 :post="post" />
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4">
      <button v-if="page < pages" class="btn btn-primary wide" @click="onClickMore">
        {{ t("Load more") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, PropType } from "vue";
import { VueMasonryPlugin } from "vue-masonry";
import BlogListItemV2 from "@/components/v2/blog-list-item/index.vue";
import { BlogPost } from "@/interfaces/Blog/BlogPost.ts";
import { useI18n } from "vue-i18n";
import rainbowSticker from "@/assets/v2/images/stickers/rainbow.svg";

const instance = getCurrentInstance();

if (instance) {
  instance.appContext.app.use(VueMasonryPlugin);
}

defineOptions({
  name: "blog-list-v2",
});

defineProps({
  posts: {
    type: Array as PropType<BlogPost[]>,
    default: () => [],
  },
  page: {
    type: Number,
    default: 1,
  },
  pages: {
    type: Number,
    default: 1,
  },
});

const { t } = useI18n();

const emit = defineEmits(["onClickMore"]);

const onClickMore = () => {
  emit("onClickMore");
};
</script>

<style lang="scss">
@import "./index";
</style>
